// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__jkci7","location":"Header_location__2PfKu"};